import { useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { useAuth, API } from "../App";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  const processAuth = useCallback(async () => {
    // Extract session_id from URL fragment
    const hash = location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);
    
    if (!sessionIdMatch) {
      toast.error("Session invalide");
      navigate("/login", { replace: true });
      return;
    }

    const sessionId = sessionIdMatch[1];

    try {
      const response = await fetch(`${API}/auth/session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ session_id: sessionId })
      });

      if (!response.ok) {
        throw new Error("Erreur d'authentification");
      }

      const userData = await response.json();
      login(userData, userData.session_token);
      toast.success("Connexion réussie !");

      // Redirect based on onboarding status
      if (userData.onboarding_completed) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/onboarding", { replace: true });
      }
    } catch (error) {
      console.error("Auth callback error:", error);
      toast.error("Erreur de connexion Google");
      navigate("/login", { replace: true });
    }
  }, [location.hash, login, navigate]);

  useEffect(() => {
    // Prevent double processing
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    processAuth();
  }, [processAuth]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#020617] flex items-center justify-center">
      <div className="text-center">
        <div className="flex justify-center mb-6 animate-pulse-glow">
          <img src="/logo-alia.png" style={{height: "80px", objectFit: "contain"}} alt="ALIA Assistant" />
        </div>
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600 dark:text-slate-400" data-testid="auth-callback-loading">
          Connexion en cours...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
